import React from 'react'
import styled from 'styled-components'

interface LineProps {
  $marginTop?: number
  $marginBottom?: number
}

const LineWrapper = styled.div`
  display: flex;
`
const Line = styled.div<LineProps>`
  display: flex;
  flex: 1;
  width: 100%;
  height: 1px;
  background-color: var(--chakra-colors-border-default);
  margin-top: ${(props) => props.$marginTop ?? 0}px;
  margin-bottom: ${(props) => props.$marginBottom ?? 0}px;
`

const StyledLine = ({
  marginTop,
  marginBottom,
}: {
  marginTop?: number
  marginBottom?: number
}) => {
  return (
    <LineWrapper>
      <Line $marginTop={marginTop} $marginBottom={marginBottom} />
    </LineWrapper>
  )
}

export { StyledLine }
